import { AxiosInstance } from "axios";
import { apiAuthUrlGet } from "../api_common";
import { axiosInstanceCreate } from "./axios_common";

const authUrlBase: string = apiAuthUrlGet();

export const axiosAuth: AxiosInstance = axiosInstanceCreate(authUrlBase);
